export const messages = {
  en: {
    affiliateWithdrawal: {
      queryCondition: 'Query Conditions',
      pleaseEnterAffiliate: 'Please enter affiliate',
      query: 'Query',
      withdrawal: 'Affiliate Withdrawal',
      withdrawalId: 'Withdrawal ID',
      affiliateId: 'Affiliate ID',
      affiliate: 'Affiliate',
      realName: 'Real Name',
      alipayAccount: 'Alipay Account',
      withdrawalAmount: 'Withdrawal Amount',
      actualAmount: 'Actual Amount',
      fee: 'Fee',
      accountType: 'Account Type',
      status: 'Status',
      auditRemark: 'Audit Remark',
      completeTime: 'Complete Time',
      createTime: 'Create Time',
      operation: 'Operation',
      audit: 'Audit',
      delete: 'Delete',
      applying: 'Applying',
      processing: 'Processing',
      completed: 'Completed',
      rejected: 'Rejected',
      alipay: 'Alipay',
      wechat: 'WeChat',
      bankCard: 'Bank Card',
      auditWithdrawal: 'Audit Withdrawal',
      totalCommission: 'Total Commission',
      availableCommission: 'Available Commission',
      withdrawnCommission: 'Withdrawn Commission',
      remark: 'Remark',
      reason: 'Reason',
      cancel: 'Cancel',
      save: 'Save',
      confirmOperation: 'Please confirm your operation',
      confirmDeleteWithdrawal: 'Confirm to delete affiliate withdrawal',
      confirmDelete: 'Confirm Delete',
      actualAmountRequired: 'Actual amount is required',
      feeRequired: 'Fee is required',
      statusRequired: 'Status is required',
      reasonRequired: 'Reason is required'
    }
  },
  zh: {
    affiliateWithdrawal: {
      queryCondition: '查询条件',
      pleaseEnterAffiliate: '请输入分销员',
      query: '查询',
      withdrawal: '分销提现',
      withdrawalId: '提现ID',
      affiliateId: '分销员ID',
      affiliate: '分销员',
      realName: '真实姓名',
      alipayAccount: '支付宝账号',
      withdrawalAmount: '提现金额',
      actualAmount: '实际到账金额',
      fee: '手续费',
      accountType: '账户类型',
      status: '状态',
      auditRemark: '审核备注',
      completeTime: '完成时间',
      createTime: '创建时间',
      operation: '操作',
      audit: '审核',
      delete: '删除',
      applying: '申请中',
      processing: '处理中',
      completed: '已完成',
      rejected: '已拒绝',
      alipay: '支付宝',
      wechat: '微信',
      bankCard: '银行卡',
      auditWithdrawal: '审核分销提现',
      totalCommission: '累计佣金',
      availableCommission: '可提现佣金',
      withdrawnCommission: '已提现佣金',
      remark: '备注信息',
      reason: '原因',
      cancel: '取消',
      save: '保存',
      confirmOperation: '请确认您的操作',
      confirmDeleteWithdrawal: '确认删除分销提现',
      confirmDelete: '确认删除',
      actualAmountRequired: '实际到账金额不能为空',
      feeRequired: '手续费不能为空',
      statusRequired: '状态不能为空',
      reasonRequired: '原因不能为空'
    }
  }
}